import { styled } from "baseui";

const Spacing = styled("div", ({ size }) => ({
  height: size ? size + "px" : "32px",
}));

export default Spacing;
